import script from "./CitizenCardPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./CitizenCardPdf.vue?vue&type=script&setup=true&lang=ts"

import "./CitizenCardPdf.vue?vue&type=style&index=0&id=b878e218&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b878e218"]])

export default __exports__